/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
	  }
export type Hour = number & { readonly __brand: unique symbol }
export type Minute = number & { readonly __brand: unique symbol }
export type UInt = number & { readonly __brand: unique symbol }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	Date: { input: string; output: string }
	DateTime: { input: string; output: string }
	UInt: { input: UInt; output: UInt }
	join__FieldSet: { input: string; output: string }
	link__Import: { input: string; output: string }
}

/** 会計金額（金額と方向のペア） */
export type AccountingAmount = {
	/** 金額（絶対値） */
	amount: Scalars["UInt"]["output"]
	/** 種別（true = SOUHL 振込方向（payout）、false = 御社支払い方向（invoice）） */
	isPayout: Scalars["Boolean"]["output"]
}

/**
 * 経理グループ（accounting_groups テーブル）。
 * 会社内の店舗を口座・請求先単位でグルーピングする。
 * 相殺処理の基本単位。
 */
export type AccountingGroup = {
	/** 口座名義（正規化済み） */
	bankAccountHolderName: Scalars["String"]["output"]
	/** 口座番号 */
	bankAccountNumber: Scalars["String"]["output"]
	/** 口座種別 */
	bankAccountType: BankAccountType
	/** 支店コード（3桁） */
	bankBranchCode: Scalars["String"]["output"]
	/** 銀行コード（4桁） */
	bankCode: Scalars["String"]["output"]
	/** 請求先メールアドレスの配列 */
	billingEmails: Array<Scalars["String"]["output"]>
	/** 会社 ID（IDP companies.id） */
	companyId: Scalars["String"]["output"]
	/** 作成日時 */
	createTime: Scalars["DateTime"]["output"]
	/** 表示名（明細・メール文面に表示する名前。当面は name と同値） */
	displayName: Scalars["String"]["output"]
	/** 経理グループ ID（ULID） */
	id: Scalars["String"]["output"]
	/** グループ名（refund-hub 上でグループを識別する名前） */
	name: Scalars["String"]["output"]
	/** 更新日時 */
	updateTime: Scalars["DateTime"]["output"]
}

/**
 * 経理グループに所属する店舗情報。
 * salonName は IDP GetSalons API から salon.DisplayName を取得して設定する。
 */
export type AccountingGroupSalon = {
	/** 解約済み店舗かどうか（IDP SkipEnqueueingScrapingSalonIDs に含まれる場合 true） */
	isArchived: Scalars["Boolean"]["output"]
	/** 店舗 ID（IDP salons.salon_id） */
	salonId: Scalars["Int"]["output"]
	/** 店舗名（IDP から取得） */
	salonName: Scalars["String"]["output"]
}

/** 店舗紐付け割当情報（editCompanyAllAccountingGroups の入力要素）。 */
export type AccountingGroupSalonAssignment = {
	/** 紐付け先の経理グループ ID（ULID） */
	accountingGroupId: Scalars["String"]["input"]
	/** 紐付ける店舗 ID リスト */
	salonIds: Array<Scalars["Int"]["input"]>
}

/** 調整金額 */
export type Adjustment = {
	/** 金額 */
	amount: AccountingAmount
	/** Adjustment ID */
	id: Scalars["ID"]["output"]
	/** 調整メモ（任意の補足説明） */
	memo: Maybe<Scalars["String"]["output"]>
	/** 調整名（例: 返金対応） */
	name: Scalars["String"]["output"]
	/** 登録日時 */
	registerTime: Scalars["DateTime"]["output"]
}

/** 追加する調整金額 */
export type AdjustmentAddition = {
	/** 金額（絶対値） */
	amount: Scalars["UInt"]["input"]
	/** 種別（true = SOUHL 振込方向、false = 御社支払い方向） */
	isAmountKindPayout: Scalars["Boolean"]["input"]
	/** 調整メモ（任意の補足説明） */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 調整名（例: 返金対応） */
	name: Scalars["String"]["input"]
}

/**
 * 年月指定の調整金額一覧を取得する。
 * delete_time IS NULL の有効レコードのみ。register_time DESC 順で返却する。
 * companyId は Service Token から取得する。
 * - [error]
 *     - NOT_FOUND: accountingGroupId が存在しない、または自社の経理グループでない場合
 */
export type AdjustmentsByYearMonthParam = {
	/** 対象の経理グループ ID */
	accountingGroupId: Scalars["ID"]["input"]
	/** 対象年月（YYYY-MM 形式） */
	yearMonth: Scalars["String"]["input"]
}

/** adjustmentsByYearMonth のレスポンス */
export type AdjustmentsByYearMonthResponse = {
	/** 調整金額一覧（register_time DESC 順。delete_time IS NULL のもののみ） */
	adjustments: Array<Adjustment>
	/** 調整金額合計（positive と negative の差分） */
	total: AccountingAmount
}

/** BestEffort スコープ操作（経理グループ編集・経理グループ詳細更新）の可否チェック */
export type AllowBestEffortScopeOperationParam = {
	/** 未使用（将来の拡張用） */
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** 口座種別。 */
export type BankAccountType =
	/** 当座預金 */
	| "CHECKING"
	/** 普通預金 */
	| "ORDINARY"

/** 会社の店舗情報 */
export type CompanySalon = {
	/** 店舗 ID */
	salonId: Scalars["Int"]["output"]
	/** 店舗名 */
	salonName: Scalars["String"]["output"]
}

/**
 * 経理グループを作成する。
 * company_admin 以上の権限でアクセス可能。
 * companyId は Service Token から取得する。
 * name・口座情報は全て必須。
 * bank_account_holder_name は保存時に正規化処理（全角→半角カタカナ、スペース統一、括弧統一、半角小文字→半角大文字カタカナ）を適用し、最終的に全て半角文字で保存する。
 * - [error]
 *     - BAD_REQUEST: name が空文字の場合
 *     - BAD_REQUEST: billingEmails 内に不正なメールアドレス形式が含まれる場合
 *     - BAD_REQUEST: bankCode が 4 桁でない場合
 *     - BAD_REQUEST: bankBranchCode が 3 桁でない場合
 *     - BAD_REQUEST: bankAccountNumber が数字以外を含む場合
 */
export type CreateAccountingGroupInput = {
	/** 口座名義（保存時に正規化処理を適用） */
	bankAccountHolderName: Scalars["String"]["input"]
	/** 口座番号 */
	bankAccountNumber: Scalars["String"]["input"]
	/** 口座種別 */
	bankAccountType: BankAccountType
	/** 支店コード（3桁） */
	bankBranchCode: Scalars["String"]["input"]
	/** 銀行コード（4桁） */
	bankCode: Scalars["String"]["input"]
	/** 請求先メールアドレスの配列 */
	billingEmails: Array<Scalars["String"]["input"]>
	/** 表示名（明細・メール文面に表示する名前。省略・空文字の場合は name と同値でバックフィルする） */
	displayName?: InputMaybe<Scalars["String"]["input"]>
	/** グループ名（必須） */
	name: Scalars["String"]["input"]
}

/** createAccountingGroup のレスポンス */
export type CreateAccountingGroupResponse = {
	/** 作成された経理グループ */
	accountingGroup: AccountingGroup
}

/**
 * Settlement の相殺明細 Excel と請求書 PDF（invoice 型のみ）をダウンロードする。
 * Excel / PDF ファイルを S3 に生成し、署名付き URL を返す。
 * Excel は 3 タブ構成: サマリー / 請求管理機能明細 / 離脱顧客獲得機能明細。
 * net_amount の正負により SOUHL 振込版 / 御社支払い版の出し分けを行う。
 * is_net_amount_kind_payout = false（invoice 型）の場合のみ請求書 PDF も生成して返す。
 * companyId は Service Token から取得する。
 * - [error]
 *     - NOT_FOUND: settlementId が存在しない、または自社の settlement でない場合
 */
export type DownloadSettlementExcelAndInvoicePdfParam = {
	/** 対象の Settlement ID */
	settlementId: Scalars["ID"]["input"]
}

/** downloadSettlementExcelAndInvoicePDF のレスポンス */
export type DownloadSettlementExcelAndInvoicePdfResponse = {
	/** 相殺明細 Excel ファイル */
	excel: DownloadUrlAndFileName
	/** 請求書 PDF ファイル。is_net_amount_kind_payout = false（invoice 型）の場合のみ返却。payout 型は null */
	invoicePdf: Maybe<DownloadUrlAndFileName>
}

/** ダウンロード URL とファイル名のペア */
export type DownloadUrlAndFileName = {
	/** 署名付き S3 URL（有効期限: 15分） */
	downloadUrl: Scalars["String"]["output"]
	/** ファイル名 */
	filename: Scalars["String"]["output"]
}

/**
 * 会社全体の経理グループ ↔ 店舗紐付けを一括変更する（マトリックス形式）。
 * souhl_admin のみアクセス可能。
 * companyId は Service Token から取得する。
 * トランザクション内で:
 * 1. 対象 company の既存 accounting_group_salons に deleted_time を設定（論理削除）
 * 2. assignments に基づいて新しい紐付けを一括 INSERT（deleted_time = NULL）
 * 3. 影響する先月の Settlement を archive & recreate。Settlement が存在しない経理グループの場合は新規作成する
 * assignments に含まれない店舗は「未割当」状態となる。
 * 同一 salon_id が複数の assignment に含まれる場合はエラー。
 * - [error]
 *     - BAD_REQUEST: assignments 内の salonIds に重複がある場合（1 店舗が複数グループに紐付いている）
 *     - BAD_REQUEST: assignments 内の accountingGroupId が自社の経理グループでない場合
 *     - BAD_REQUEST: salonIds に自社に属さない salon_id が含まれる場合
 */
export type EditCompanyAllAccountingGroupsInput = {
	/** 経理グループごとの店舗割当リスト */
	assignments: Array<AccountingGroupSalonAssignment>
}

/** editCompanyAllAccountingGroups のレスポンス */
export type EditCompanyAllAccountingGroupsResponse = {
	/** 更新後の経理グループ一覧（create_time ASC の順で返却） */
	accountingGroups: Array<AccountingGroup>
}

/**
 * 年月指定で調整金額の追加・削除を行う（souhl_admin のみ）。
 * 同一トランザクション内で対象年月の settlement を archive & recreate する。
 * companyId は Service Token から取得する。
 * - [error]
 *     - FORBIDDEN: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: accountingGroupId が存在しない、または自社の経理グループでない場合
 *     - BAD_REQUEST: 対象年月の settlement が pending 以外の場合（settlement が存在する場合）
 *     - BAD_REQUEST: deletionIds に指定された accountingGroupId / yearMonth 以外の adjustment が含まれる場合
 */
export type EditYearMonthAdjustmentsInput = {
	/** 対象の経理グループ ID */
	accountingGroupId: Scalars["ID"]["input"]
	/** 追加する調整 */
	additions: Array<AdjustmentAddition>
	/** 削除する調整の ID */
	deletionIds: Array<Scalars["ID"]["input"]>
	/** 対象年月（YYYY-MM 形式） */
	yearMonth: Scalars["String"]["input"]
}

/** editYearMonthAdjustments のレスポンス */
export type EditYearMonthAdjustmentsResponse = {
	dummy: Maybe<Scalars["String"]["output"]>
}

/**
 * 経理グループの詳細を取得する（所属店舗一覧含む）。
 * company_admin 以上の権限でアクセス可能。
 * companyId は Service Token から取得し、対象グループが自社に属することを検証する。
 * - [error]
 *     - NOT_FOUND: 指定の accountingGroupId が存在しない、または自社の経理グループでない場合
 */
export type GetAccountingGroupDetailParam = {
	/** 取得対象の経理グループ ID（ULID） */
	accountingGroupId: Scalars["String"]["input"]
}

/** getAccountingGroupDetail のレスポンス */
export type GetAccountingGroupDetailResponse = {
	/** 経理グループ詳細 */
	accountingGroup: AccountingGroup
	/** 御社未払い金額（is_net_amount_kind_payout=false かつ status が completed/archived/carryover 以外の settlement の net_amount 合計） */
	companyUnpaidAmount: Scalars["UInt"]["output"]
	/** 所属店舗一覧（salonName は IDP GetSalons → salon.DisplayName から取得。salon_id ASC の順で返却） */
	salons: Array<AccountingGroupSalon>
	/** SOUHL 未振込金額（is_net_amount_kind_payout=true かつ status が completed/archived/carryover 以外の settlement の net_amount 合計） */
	souhlUnpaidAmount: Scalars["UInt"]["output"]
	/** 未払い金額の対象成果月（該当する settlement の year_month。未払いなしの場合は null） */
	unpaidUntil: Maybe<YearMonth>
}

/**
 * 会社の経理グループ一覧を取得する。
 * company_admin 以上の権限でアクセス可能。
 * companyId は Service Token から取得するため、param は dummy。
 * - [error]
 *     （エラーなし。グループが 0 件の場合は空配列を返す）
 */
export type GetAccountingGroupsParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** getAccountingGroups のレスポンス */
export type GetAccountingGroupsResponse = {
	/** 経理グループ一覧（create_time ASC の順で返却） */
	accountingGroups: Array<AccountingGroup>
}

/**
 * 会社の全店舗一覧と会社名を取得する。
 * company_admin / souhl_admin の両方がアクセス可能。
 * companyId は Service Token から取得するため、param は dummy。
 */
export type GetCompanySalonsParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** getCompanySalons のレスポンス */
export type GetCompanySalonsResponse = {
	/** 会社名 */
	companyName: Scalars["String"]["output"]
	/** 店舗一覧（salon_id ASC 順） */
	salons: Array<CompanySalon>
}

export type ManuallyUpdateRereservationStatusItem = {
	/** 更新対象の cancel_id（= rereservation の PK） */
	cancelId: Scalars["String"]["input"]
	/** 更新先のステータス */
	newStatus: RereservationStatusInput
}

/**
 * 指定した rereservation のステータスを一括手動更新する（souhl_admin のみ）。
 * 内部的には Cancy Proto Private API ManuallyUpdateRereservationStatuses を呼び出す。
 * cancel_id ごとに異なるステータスを指定できる。
 * - [error]
 *     - FORBIDDEN: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: cancel_id に対応する rereservation が存在しない場合
 */
export type ManuallyUpdateRereservationStatusesInput = {
	/** 更新対象の cancel_id とステータスのペアリスト */
	items: Array<ManuallyUpdateRereservationStatusItem>
	/** 対象の Settlement ID */
	settlementId: Scalars["ID"]["input"]
}

/** 手動ステータス一括更新の結果 */
export type ManuallyUpdateRereservationStatusesPayload = {
	/** ダミーフィールド */
	success: Scalars["Boolean"]["output"]
}

export type Mutation = {
	createAccountingGroup: CreateAccountingGroupResponse
	editCompanyAllAccountingGroups: EditCompanyAllAccountingGroupsResponse
	editYearMonthAdjustments: EditYearMonthAdjustmentsResponse
	manuallyUpdateRereservationStatuses: ManuallyUpdateRereservationStatusesPayload
	recreateSettlement: RecreateSettlementResponse
	updateAccountingGroupDetail: UpdateAccountingGroupDetailResponse
}

export type MutationCreateAccountingGroupArgs = {
	input: CreateAccountingGroupInput
}

export type MutationEditCompanyAllAccountingGroupsArgs = {
	input: EditCompanyAllAccountingGroupsInput
}

export type MutationEditYearMonthAdjustmentsArgs = {
	input: EditYearMonthAdjustmentsInput
}

export type MutationManuallyUpdateRereservationStatusesArgs = {
	input: ManuallyUpdateRereservationStatusesInput
}

export type MutationRecreateSettlementArgs = {
	input: RecreateSettlementInput
}

export type MutationUpdateAccountingGroupDetailArgs = {
	input: UpdateAccountingGroupDetailInput
}

export type Query = {
	adjustmentsByYearMonth: AdjustmentsByYearMonthResponse
	allowBestEffortScopeOperation: Maybe<Scalars["String"]["output"]>
	downloadSettlementExcelAndInvoicePDF: DownloadSettlementExcelAndInvoicePdfResponse
	getAccountingGroupDetail: GetAccountingGroupDetailResponse
	getAccountingGroups: GetAccountingGroupsResponse
	/** 会社の全店舗一覧と会社名を返す */
	getCompanySalons: GetCompanySalonsResponse
	/** company_admin supergraph が起動していることを返します */
	hello: Scalars["String"]["output"]
	settlementDetail: SettlementDetailResponse
	settlementRereservations: Array<SettlementRereservation>
	settlements: SettlementsResponse
}

export type QueryAdjustmentsByYearMonthArgs = {
	param: AdjustmentsByYearMonthParam
}

export type QueryAllowBestEffortScopeOperationArgs = {
	param: AllowBestEffortScopeOperationParam
}

export type QueryDownloadSettlementExcelAndInvoicePdfArgs = {
	param: DownloadSettlementExcelAndInvoicePdfParam
}

export type QueryGetAccountingGroupDetailArgs = {
	param: GetAccountingGroupDetailParam
}

export type QueryGetAccountingGroupsArgs = {
	param: GetAccountingGroupsParam
}

export type QueryGetCompanySalonsArgs = {
	param: GetCompanySalonsParam
}

export type QuerySettlementDetailArgs = {
	param: SettlementDetailParam
}

export type QuerySettlementRereservationsArgs = {
	param: SettlementRereservationsParam
}

export type QuerySettlementsArgs = {
	param: SettlementsParam
}

/**
 * 今月の明細をアーカイブし最新データで再作成する（souhl_admin のみ）。
 * Settlement 作成のコアロジック（archive & recreate パターン）を実行する。
 * companyId は Service Token から取得する。
 * - [error]
 *     - FORBIDDEN: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: accountingGroupId が存在しない、または自社の経理グループでない場合
 *     - NOT_FOUND: settlementId が存在しない場合
 *     - BAD_REQUEST: ステータスが pending 以外の場合
 */
export type RecreateSettlementInput = {
	/** 対象の Settlement ID */
	settlementId: Scalars["ID"]["input"]
}

/** recreateSettlement のレスポンス */
export type RecreateSettlementResponse = {
	/** 再作成された Settlement */
	settlement: Settlement
}

/** 再予約確認ステータス（出力用） */
export type RereservationConfirmationStatus =
	/** 再予約がキャンセルされた */
	| "CANCELLED"
	/** 未確定 */
	| "UNCONFIRMED"
	/** 顧客が来店した */
	| "VISITED"

/** 手動更新で指定可能な rereservation ステータス */
export type RereservationStatusInput =
	/** 再予約がキャンセルされた */
	| "CANCELLED"
	/** 未確定（ステータスを元に戻す場合に使用） */
	| "UNCONFIRMED"
	/** 顧客が来店した */
	| "VISITED"

/**
 * 相殺明細。経理グループスナップショットに紐づく月次の相殺明細。
 *
 * 導出フィールド（DB カラムなし、resolver で計算）:
 * - yearMonth: DB は VARCHAR(7) "YYYY-MM" で保持、GraphQL では YearMonth type に変換
 * - souhlCarryoverAmount / companyCarryoverAmount / carryoverYearMonth: last_month_settlement_id → 前月 settlement の final_amount / is_final_amount_kind_payout / year_month から導出。前月なしまたは carryover なしの場合 null
 * - cancelFeeCommissionRate / rereservationCommissionRate: accounting_group_settings_snapshots テーブルから取得
 * - companyPaymentDue: isFinalAmountKindPayout=false の場合のみ、yearMonth の次月末日を計算して返す
 */
export type Settlement = {
	/** 請求管理機能サービス手数料（税抜）= floor(totalPaidCancelFee × cancelFeeCommissionRate / 100) */
	cancelFeeCommissionExclTax: Scalars["UInt"]["output"]
	/** 請求管理機能サービス手数料（税込、表示用）= floor(cancelFeeCommissionExclTax × 110 / 100) */
	cancelFeeCommissionInclTax: Scalars["UInt"]["output"]
	/** 回収手数料率（スナップショットから取得。税抜整数 %） */
	cancelFeeCommissionRate: Scalars["Int"]["output"]
	/** キャリーオーバー元の成果月。キャリーオーバーなしの場合は null */
	carryoverYearMonth: Maybe<YearMonth>
	/** 御社方向のキャリーオーバー金額（絶対値）。キャリーオーバーなしの場合は null */
	companyCarryoverAmount: Maybe<Scalars["UInt"]["output"]>
	/** 御社お支払期限（御社支払い（invoice）の場合のみ。yearMonth の次月末日） */
	companyPaymentDue: Maybe<Scalars["Date"]["output"]>
	/** 既存客の再予約手数料率（スナップショットから取得。税抜整数 %） */
	existingCustomerRereservationCommissionRate: Scalars["Int"]["output"]
	/** 最終金額 */
	finalAmount: AccountingAmount
	/** 振込手数料差引前の最終金額 */
	finalAmountExclTransferFee: AccountingAmount
	/** 未確定ステータスの再予約を含むか */
	hasUnconfirmedRereservation: Scalars["Boolean"]["output"]
	/** Settlement ID */
	id: Scalars["ID"]["output"]
	/** 新規客の再予約手数料率（スナップショットから取得。税抜整数 %） */
	newCustomerRereservationCommissionRate: Scalars["Int"]["output"]
	/** salon への振込額（= totalPaidCancelFee - cancelFeeCommissionInclTax） */
	payoutAmount: Scalars["UInt"]["output"]
	/** 登録日時 */
	registerTime: Scalars["DateTime"]["output"]
	/** 離脱顧客獲得機能サービス手数料（税抜）= floor(totalRereservationAmount × rereservationCommissionRate / 100) */
	rereservationCommissionExclTax: Scalars["UInt"]["output"]
	/** 離脱顧客獲得機能サービス手数料（税込、表示用）= floor(rereservationCommissionExclTax × 110 / 100) */
	rereservationCommissionInclTax: Scalars["UInt"]["output"]
	/**
	 * 再予約手数料率（スナップショットから取得。税抜整数 %）。新規客/既存客で分離したため非推奨。
	 * @deprecated 新規客/既存客で利率を分離しました。existingCustomerRereservationCommissionRate を使用してください。
	 */
	rereservationCommissionRate: Scalars["Int"]["output"]
	/** SOUHL 方向のキャリーオーバー金額（絶対値）。キャリーオーバーなしの場合は null */
	souhlCarryoverAmount: Maybe<Scalars["UInt"]["output"]>
	/** ステータス */
	status: SettlementStatus
	/** 消費税額 = floor(totalCommissionExclTax × 0.1) */
	taxAmount: Scalars["UInt"]["output"]
	/** 調整金額合計 */
	totalAdjustment: AccountingAmount
	/** 税抜手数料合計 = cancelFeeCommissionExclTax + rereservationCommissionExclTax */
	totalCommissionExclTax: Scalars["UInt"]["output"]
	/** 税込手数料合計 = totalCommissionExclTax + taxAmount */
	totalCommissionInclTax: Scalars["UInt"]["output"]
	/** 回収金額合計 */
	totalPaidCancelFee: Scalars["UInt"]["output"]
	/** 再予約金額合計 */
	totalRereservationAmount: Scalars["UInt"]["output"]
	/** 振込手数料（isFinalAmountKindPayout=true: 220 円、false: 0 円） */
	transferFee: Scalars["UInt"]["output"]
	/** 成果月 */
	yearMonth: YearMonth
}

/** 相殺明細の詳細。操作可否判定を含む。 */
export type SettlementDetail = {
	/** 再予約明細行一覧（start_time DESC 順。Settlement 作成時に Cancy から取得したデータ） */
	rereservations: Array<SettlementRereservation>
	/** Settlement 基本情報 */
	settlement: Settlement
	/** Strict スコープ操作の拒否理由。null なら操作可能（editAdjustments / recreateSettlement / updateRereservationStatuses が対象） */
	strictScopeOperationDeniedReason: Maybe<Scalars["String"]["output"]>
}

/**
 * 相殺明細の詳細を取得する。
 * settlement_rereservations を含む。
 * 操作可否判定（canRecreate / canUpdateRereservationStatus）も返す。
 * companyId は Service Token から取得する。
 * - [error]
 *     - NOT_FOUND: accountingGroupId が存在しない、または自社の経理グループでない場合
 *     - NOT_FOUND: settlementId が存在しない場合
 */
export type SettlementDetailParam = {
	/** 対象の Settlement ID */
	settlementId: Scalars["ID"]["input"]
}

/** settlementDetail のレスポンス */
export type SettlementDetailResponse = {
	/** 相殺明細詳細 */
	detail: SettlementDetail
}

/** 再予約明細行（詳細画面用。settlementRereservations でも同じ型を返す） */
export type SettlementRereservation = {
	/** 再予約金額（= rereservations.price. DISCOUNT incentive 時は値引き後金額） */
	amount: Scalars["UInt"]["output"]
	/** cancel_id */
	cancelId: Scalars["String"]["output"]
	/** 顧客名 */
	customerName: Scalars["String"]["output"]
	/** 新規客かどうか（rh_cancels.visit_counts == 0 で判定） */
	isNewCustomer: Scalars["Boolean"]["output"]
	/** 再予約日時（再予約が検知された日時。rereservations.register_time） */
	rereservedTime: Scalars["DateTime"]["output"]
	/** 店舗 ID */
	salonId: Scalars["Int"]["output"]
	/** 店舗名（accounting_group_salon_snapshots から取得） */
	salonName: Scalars["String"]["output"]
	/** スタッフ名 */
	staffName: Maybe<Scalars["String"]["output"]>
	/** 来店日時（再来店予定日時。rereservations.start_time） */
	startTime: Scalars["DateTime"]["output"]
	/** 確認ステータス */
	status: RereservationConfirmationStatus
}

/**
 * Settlement に紐づく rereservation 一覧を取得する（souhl_admin のみ）。
 * idea-4 で実装予定。現在はスタブとして空配列を返す。
 * - [error]
 *     - FORBIDDEN: souhl_admin でないユーザーがアクセスした場合
 */
export type SettlementRereservationsParam = {
	/** 対象の Settlement ID */
	settlementId: Scalars["ID"]["input"]
}

/** 相殺明細のステータス */
export type SettlementStatus =
	/** 来月繰越 */
	| "CARRYOVER"
	/** 完了 */
	| "COMPLETED"
	/** 御社支払い確認中 */
	| "INVOICE_IN_PROGRESS"
	/** SOUHL 振込確認中 */
	| "PAYOUT_IN_PROGRESS"
	/** 保留中 */
	| "PENDING"

/**
 * 指定した経理グループの相殺明細一覧を取得する。
 * archived ステータスは除外。年月降順で返却する。
 * souhl admin の場合のみ、pending ステータスの settlement も返却する。
 * companyId は Service Token から取得する。
 * - [error]
 *     - NOT_FOUND: accountingGroupId が存在しない、または自社の経理グループでない場合
 */
export type SettlementsParam = {
	/** 対象の経理グループ ID */
	accountingGroupId: Scalars["ID"]["input"]
}

/** settlements のレスポンス */
export type SettlementsResponse = {
	/** 相殺明細一覧（年月降順、archived を除く） */
	settlements: Array<Settlement>
}

/**
 * 経理グループの詳細を更新する（口座情報・請求先メール）。
 * company_admin 以上の権限でアクセス可能。
 * companyId は Service Token から取得し、対象グループが自社に属することを検証する。
 * bank_account_holder_name は保存時に正規化処理を適用する。
 * 更新後、先月の Settlement が存在する場合は snapshot の値が変わるため再作成する（存在しない場合はスキップ）。
 * - [error]
 *     - NOT_FOUND: 指定の accountingGroupId が存在しない、または自社の経理グループでない場合
 *     - BAD_REQUEST: name が空文字の場合
 *     - BAD_REQUEST: billingEmails 内に不正なメールアドレス形式が含まれる場合
 *     - BAD_REQUEST: bankCode が 4 桁でない場合
 *     - BAD_REQUEST: bankBranchCode が 3 桁でない場合
 *     - BAD_REQUEST: bankAccountNumber が数字以外を含む場合
 */
export type UpdateAccountingGroupDetailInput = {
	/** 更新対象の経理グループ ID（ULID） */
	accountingGroupId: Scalars["String"]["input"]
	/** 口座名義（保存時に正規化処理を適用） */
	bankAccountHolderName: Scalars["String"]["input"]
	/** 口座番号 */
	bankAccountNumber: Scalars["String"]["input"]
	/** 口座種別 */
	bankAccountType: BankAccountType
	/** 支店コード（3桁） */
	bankBranchCode: Scalars["String"]["input"]
	/** 銀行コード（4桁） */
	bankCode: Scalars["String"]["input"]
	/** 請求先メールアドレスの配列 */
	billingEmails: Array<Scalars["String"]["input"]>
	/** 表示名（明細・メール文面に表示する名前） */
	displayName: Scalars["String"]["input"]
	/** グループ名 */
	name: Scalars["String"]["input"]
}

/** updateAccountingGroupDetail のレスポンス */
export type UpdateAccountingGroupDetailResponse = {
	/** 更新後の経理グループ */
	accountingGroup: AccountingGroup
}

/** 年月 */
export type YearMonth = {
	/** 月（1-12） */
	month: Scalars["Int"]["output"]
	/** 年（例: 2026） */
	year: Scalars["Int"]["output"]
}

export type Join__Graph =
	| "ACCOUNTING_COMPANY_ADMIN"
	| "CANCY_COMPANY_ADMIN"
	| "IDP_COMPANY_ADMIN"

export type Link__Purpose =
	/** `EXECUTION` features provide metadata necessary for operation execution. */
	| "EXECUTION"
	/** `SECURITY` features provide metadata necessary to securely resolve fields. */
	| "SECURITY"

export type GetSettlementsQueryVariables = Exact<{
	param: SettlementsParam
}>

export type GetSettlementsQuery = {
	settlements: {
		settlements: Array<{
			" $fragmentRefs"?: { SettlementFieldsFragment: SettlementFieldsFragment }
		}>
	}
}

export type AccountingGroupFieldsFragment = {
	id: string
	companyId: string
	name: string
	displayName: string
	bankCode: string
	bankBranchCode: string
	bankAccountType: BankAccountType
	bankAccountNumber: string
	bankAccountHolderName: string
	billingEmails: Array<string>
	createTime: string
	updateTime: string
} & { " $fragmentName"?: "AccountingGroupFieldsFragment" }

export type AccountingGroupSalonFieldsFragment = {
	salonId: number
	salonName: string
	isArchived: boolean
} & { " $fragmentName"?: "AccountingGroupSalonFieldsFragment" }

export type GetAccountingGroupsQueryVariables = Exact<{
	param: GetAccountingGroupsParam
}>

export type GetAccountingGroupsQuery = {
	getAccountingGroups: {
		accountingGroups: Array<{
			" $fragmentRefs"?: {
				AccountingGroupFieldsFragment: AccountingGroupFieldsFragment
			}
		}>
	}
}

export type GetAccountingGroupDetailQueryVariables = Exact<{
	param: GetAccountingGroupDetailParam
}>

export type GetAccountingGroupDetailQuery = {
	getAccountingGroupDetail: {
		souhlUnpaidAmount: UInt
		companyUnpaidAmount: UInt
		accountingGroup: {
			" $fragmentRefs"?: {
				AccountingGroupFieldsFragment: AccountingGroupFieldsFragment
			}
		}
		salons: Array<{
			" $fragmentRefs"?: {
				AccountingGroupSalonFieldsFragment: AccountingGroupSalonFieldsFragment
			}
		}>
		unpaidUntil: { year: number; month: number } | null
	}
}

export type CreateAccountingGroupMutationVariables = Exact<{
	input: CreateAccountingGroupInput
}>

export type CreateAccountingGroupMutation = {
	createAccountingGroup: { accountingGroup: { id: string } }
}

export type EditMappingSalonFieldsFragment = {
	salonId: number
	salonName: string
} & { " $fragmentName"?: "EditMappingSalonFieldsFragment" }

export type EditMappingGetAccountingGroupDetailQueryVariables = Exact<{
	param: GetAccountingGroupDetailParam
}>

export type EditMappingGetAccountingGroupDetailQuery = {
	getAccountingGroupDetail: {
		salons: Array<{
			" $fragmentRefs"?: {
				EditMappingSalonFieldsFragment: EditMappingSalonFieldsFragment
			}
		}>
	}
}

export type EditCompanyAllAccountingGroupsMutationVariables = Exact<{
	input: EditCompanyAllAccountingGroupsInput
}>

export type EditCompanyAllAccountingGroupsMutation = {
	editCompanyAllAccountingGroups: { accountingGroups: Array<{ id: string }> }
}

export type GetAdjustmentsByYearMonthQueryVariables = Exact<{
	param: AdjustmentsByYearMonthParam
}>

export type GetAdjustmentsByYearMonthQuery = {
	adjustmentsByYearMonth: {
		adjustments: Array<{
			" $fragmentRefs"?: { AdjustmentFieldsFragment: AdjustmentFieldsFragment }
		}>
		total: {
			" $fragmentRefs"?: {
				AccountingAmountFieldsFragment: AccountingAmountFieldsFragment
			}
		}
	}
}

export type EditYearMonthAdjustmentsMutationVariables = Exact<{
	input: EditYearMonthAdjustmentsInput
}>

export type EditYearMonthAdjustmentsMutation = {
	editYearMonthAdjustments: { dummy: string | null }
}

export type AdjustmentFieldsFragment = {
	id: string
	name: string
	memo: string | null
	registerTime: string
	amount: { amount: UInt; isPayout: boolean }
} & { " $fragmentName"?: "AdjustmentFieldsFragment" }

export type AccountingAmountFieldsFragment = {
	amount: UInt
	isPayout: boolean
} & { " $fragmentName"?: "AccountingAmountFieldsFragment" }

export type UpdateAccountingGroupDetailMutationVariables = Exact<{
	input: UpdateAccountingGroupDetailInput
}>

export type UpdateAccountingGroupDetailMutation = {
	updateAccountingGroupDetail: {
		accountingGroup: {
			" $fragmentRefs"?: {
				AccountingGroupFieldsFragment: AccountingGroupFieldsFragment
			}
		}
	}
}

export type RecreateSettlementMutationVariables = Exact<{
	input: RecreateSettlementInput
}>

export type RecreateSettlementMutation = {
	recreateSettlement: { settlement: { id: string } }
}

export type GetSettlementRereservationsQueryVariables = Exact<{
	param: SettlementRereservationsParam
}>

export type GetSettlementRereservationsQuery = {
	settlementRereservations: Array<{
		cancelId: string
		salonId: number
		amount: UInt
		startTime: string
		customerName: string
		staffName: string | null
		status: RereservationConfirmationStatus
	}>
}

export type ManuallyUpdateRereservationStatusesMutationVariables = Exact<{
	input: ManuallyUpdateRereservationStatusesInput
}>

export type ManuallyUpdateRereservationStatusesMutation = {
	manuallyUpdateRereservationStatuses: { success: boolean }
}

export type SettlementFieldsFragment = ({
	id: string
	status: SettlementStatus
	yearMonth: { year: number; month: number }
	finalAmount: { isPayout: boolean }
} & {
	" $fragmentRefs"?: {
		SettlementTableFieldsFragment: SettlementTableFieldsFragment
	}
}) & { " $fragmentName"?: "SettlementFieldsFragment" }

export type SettlementTableFieldsFragment = {
	id: string
	status: SettlementStatus
	totalPaidCancelFee: UInt
	cancelFeeCommissionExclTax: UInt
	totalRereservationAmount: UInt
	rereservationCommissionExclTax: UInt
	souhlCarryoverAmount: UInt | null
	companyCarryoverAmount: UInt | null
	transferFee: UInt
	companyPaymentDue: string | null
	hasUnconfirmedRereservation: boolean
	yearMonth: { year: number; month: number }
	totalAdjustment: { amount: UInt; isPayout: boolean }
	finalAmount: { amount: UInt; isPayout: boolean }
} & { " $fragmentName"?: "SettlementTableFieldsFragment" }

export type DownloadSettlementExcelAndInvoicePdfQueryVariables = Exact<{
	param: DownloadSettlementExcelAndInvoicePdfParam
}>

export type DownloadSettlementExcelAndInvoicePdfQuery = {
	downloadSettlementExcelAndInvoicePDF: {
		excel: { downloadUrl: string; filename: string }
		invoicePdf: { downloadUrl: string; filename: string } | null
	}
}

export type GetCompanySalonsQueryVariables = Exact<{
	param: GetCompanySalonsParam
}>

export type GetCompanySalonsQuery = {
	getCompanySalons: {
		companyName: string
		salons: Array<{ salonId: number; salonName: string }>
	}
}

export const AccountingGroupFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingGroupFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroup" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "companyId" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "bankCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankBranchCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountType" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "bankAccountHolderName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "billingEmails" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
					{ kind: "Field", name: { kind: "Name", value: "updateTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<AccountingGroupFieldsFragment, unknown>
export const AccountingGroupSalonFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingGroupSalonFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroupSalon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "salonName" } },
					{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
				],
			},
		},
	],
} as unknown as DocumentNode<AccountingGroupSalonFieldsFragment, unknown>
export const EditMappingSalonFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "EditMappingSalonFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroupSalon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "salonName" } },
				],
			},
		},
	],
} as unknown as DocumentNode<EditMappingSalonFieldsFragment, unknown>
export const AdjustmentFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AdjustmentFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Adjustment" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "amount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "memo" } },
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<AdjustmentFieldsFragment, unknown>
export const AccountingAmountFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingAmountFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingAmount" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "amount" } },
					{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
				],
			},
		},
	],
} as unknown as DocumentNode<AccountingAmountFieldsFragment, unknown>
export const SettlementTableFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SettlementTableFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Settlement" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "yearMonth" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "year" } },
								{ kind: "Field", name: { kind: "Name", value: "month" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "totalPaidCancelFee" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelFeeCommissionExclTax" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "totalRereservationAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationCommissionExclTax" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "souhlCarryoverAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "companyCarryoverAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "totalAdjustment" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "finalAmount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "transferFee" } },
					{ kind: "Field", name: { kind: "Name", value: "companyPaymentDue" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "hasUnconfirmedRereservation" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SettlementTableFieldsFragment, unknown>
export const SettlementFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SettlementFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Settlement" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "yearMonth" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "year" } },
								{ kind: "Field", name: { kind: "Name", value: "month" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "finalAmount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SettlementTableFields" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SettlementTableFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Settlement" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "yearMonth" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "year" } },
								{ kind: "Field", name: { kind: "Name", value: "month" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "totalPaidCancelFee" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelFeeCommissionExclTax" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "totalRereservationAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationCommissionExclTax" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "souhlCarryoverAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "companyCarryoverAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "totalAdjustment" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "finalAmount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "transferFee" } },
					{ kind: "Field", name: { kind: "Name", value: "companyPaymentDue" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "hasUnconfirmedRereservation" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SettlementFieldsFragment, unknown>
export const GetSettlementsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSettlements" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SettlementsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "settlements" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "settlements" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "SettlementFields" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SettlementTableFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Settlement" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "yearMonth" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "year" } },
								{ kind: "Field", name: { kind: "Name", value: "month" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "totalPaidCancelFee" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelFeeCommissionExclTax" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "totalRereservationAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationCommissionExclTax" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "souhlCarryoverAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "companyCarryoverAmount" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "totalAdjustment" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "finalAmount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "transferFee" } },
					{ kind: "Field", name: { kind: "Name", value: "companyPaymentDue" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "hasUnconfirmedRereservation" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SettlementFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Settlement" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "yearMonth" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "year" } },
								{ kind: "Field", name: { kind: "Name", value: "month" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "finalAmount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SettlementTableFields" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GetSettlementsQuery, GetSettlementsQueryVariables>
export const GetAccountingGroupsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetAccountingGroups" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GetAccountingGroupsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "getAccountingGroups" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "accountingGroups" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "AccountingGroupFields" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingGroupFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroup" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "companyId" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "bankCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankBranchCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountType" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "bankAccountHolderName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "billingEmails" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
					{ kind: "Field", name: { kind: "Name", value: "updateTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetAccountingGroupsQuery,
	GetAccountingGroupsQueryVariables
>
export const GetAccountingGroupDetailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetAccountingGroupDetail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GetAccountingGroupDetailParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "getAccountingGroupDetail" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "accountingGroup" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "AccountingGroupFields" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salons" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "AccountingGroupSalonFields",
												},
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "souhlUnpaidAmount" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "companyUnpaidAmount" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "unpaidUntil" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "year" } },
											{ kind: "Field", name: { kind: "Name", value: "month" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingGroupFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroup" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "companyId" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "bankCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankBranchCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountType" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "bankAccountHolderName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "billingEmails" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
					{ kind: "Field", name: { kind: "Name", value: "updateTime" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingGroupSalonFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroupSalon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "salonName" } },
					{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetAccountingGroupDetailQuery,
	GetAccountingGroupDetailQueryVariables
>
export const CreateAccountingGroupDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateAccountingGroup" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateAccountingGroupInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createAccountingGroup" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "accountingGroup" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateAccountingGroupMutation,
	CreateAccountingGroupMutationVariables
>
export const EditMappingGetAccountingGroupDetailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "EditMappingGetAccountingGroupDetail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GetAccountingGroupDetailParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "getAccountingGroupDetail" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salons" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "EditMappingSalonFields" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "EditMappingSalonFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroupSalon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "salonId" } },
					{ kind: "Field", name: { kind: "Name", value: "salonName" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	EditMappingGetAccountingGroupDetailQuery,
	EditMappingGetAccountingGroupDetailQueryVariables
>
export const EditCompanyAllAccountingGroupsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "EditCompanyAllAccountingGroups" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "EditCompanyAllAccountingGroupsInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "editCompanyAllAccountingGroups" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "accountingGroups" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	EditCompanyAllAccountingGroupsMutation,
	EditCompanyAllAccountingGroupsMutationVariables
>
export const GetAdjustmentsByYearMonthDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetAdjustmentsByYearMonth" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "AdjustmentsByYearMonthParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "adjustmentsByYearMonth" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "adjustments" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "AdjustmentFields" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "total" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "AccountingAmountFields" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AdjustmentFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Adjustment" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "amount" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "memo" } },
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingAmountFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingAmount" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "amount" } },
					{ kind: "Field", name: { kind: "Name", value: "isPayout" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetAdjustmentsByYearMonthQuery,
	GetAdjustmentsByYearMonthQueryVariables
>
export const EditYearMonthAdjustmentsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "EditYearMonthAdjustments" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "EditYearMonthAdjustmentsInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "editYearMonthAdjustments" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "dummy" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	EditYearMonthAdjustmentsMutation,
	EditYearMonthAdjustmentsMutationVariables
>
export const UpdateAccountingGroupDetailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateAccountingGroupDetail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateAccountingGroupDetailInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateAccountingGroupDetail" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "accountingGroup" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "AccountingGroupFields" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "AccountingGroupFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "AccountingGroup" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "companyId" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "bankCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankBranchCode" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountType" } },
					{ kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "bankAccountHolderName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "billingEmails" } },
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
					{ kind: "Field", name: { kind: "Name", value: "updateTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateAccountingGroupDetailMutation,
	UpdateAccountingGroupDetailMutationVariables
>
export const RecreateSettlementDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "RecreateSettlement" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "RecreateSettlementInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "recreateSettlement" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "settlement" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	RecreateSettlementMutation,
	RecreateSettlementMutationVariables
>
export const GetSettlementRereservationsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSettlementRereservations" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SettlementRereservationsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "settlementRereservations" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelId" } },
								{ kind: "Field", name: { kind: "Name", value: "salonId" } },
								{ kind: "Field", name: { kind: "Name", value: "amount" } },
								{ kind: "Field", name: { kind: "Name", value: "startTime" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "customerName" },
								},
								{ kind: "Field", name: { kind: "Name", value: "staffName" } },
								{ kind: "Field", name: { kind: "Name", value: "status" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSettlementRereservationsQuery,
	GetSettlementRereservationsQueryVariables
>
export const ManuallyUpdateRereservationStatusesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ManuallyUpdateRereservationStatuses" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ManuallyUpdateRereservationStatusesInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "manuallyUpdateRereservationStatuses",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "success" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ManuallyUpdateRereservationStatusesMutation,
	ManuallyUpdateRereservationStatusesMutationVariables
>
export const DownloadSettlementExcelAndInvoicePdfDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "DownloadSettlementExcelAndInvoicePDF" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "DownloadSettlementExcelAndInvoicePDFParam",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "downloadSettlementExcelAndInvoicePDF",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "excel" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "downloadUrl" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "filename" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "invoicePdf" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "downloadUrl" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "filename" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	DownloadSettlementExcelAndInvoicePdfQuery,
	DownloadSettlementExcelAndInvoicePdfQueryVariables
>
export const GetCompanySalonsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanySalons" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GetCompanySalonsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "getCompanySalons" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "companyName" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "salons" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "salonId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "salonName" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanySalonsQuery,
	GetCompanySalonsQueryVariables
>
